export default __webpack_public_path__ + "static/media/TodoMockUp.c2b82878.jpg";